import { CornerData } from "api/types/sketch";
import { Vector2 } from "api/types/sketch";
import { drawPrintCutRadiusCorner } from "./radius_corner";
import { drawPrintCutInsideRadiusCorner } from "./inside_radius_corner";
import { drawPrintCutNotchedCorner } from "./notched_corner";
import { drawPrintCutClippedCorner } from "./clipped_corner";
import { drawPrintCutDiagonalCorner } from "./diagonal_corner";
import { drawPrintCutRecessedDiagonalCorner } from "./recessed_diagonal_corner";
import { drawPrintCutBumpoutCorner } from "./bumpout_corner";
import { drawPrintCutStandardCorner } from "./standard_corner";
import { RADIUS } from "values/quote";
import { INNER_RADIUS } from "values/quote";
import { NOTCH } from "values/quote";
import { BUMPOUT } from "values/quote";
import { CLIP } from "values/quote";
import { RECESSED_DIAGONAL } from "values/quote";
import { DIAGONAL } from "values/quote";

export function drawPrintCutCorner(
    i: number,
    painter: any,
    corner_type: string,
    previous_location: Vector2,
    current_location: Vector2,
    next_location: Vector2,
    zoom: number,
    radius: number,
    length: number,
    depth: number
): CornerData | null {
    let corner_data: CornerData | null = null;
    if(corner_type === RADIUS){
        corner_data = drawPrintCutRadiusCorner(
            painter,
            i,
            previous_location,
            current_location,
            next_location,
            radius,
            zoom
        );
    }
    else if(corner_type === INNER_RADIUS){
        corner_data = drawPrintCutInsideRadiusCorner(
            painter,
            i,
            previous_location,
            current_location,
            next_location,
            radius,
            zoom
        );
    }
    else if(corner_type === NOTCH){
        corner_data = drawPrintCutNotchedCorner(
            painter,
            i,
            previous_location,
            current_location,
            next_location,
            length,
            depth,
            zoom
        );
    }
    else if(corner_type === CLIP){
        corner_data = drawPrintCutClippedCorner(
            painter,
            i,
            previous_location,
            current_location,
            next_location,
            length,
            zoom
        );
    }
    else if(corner_type === DIAGONAL){
        corner_data = drawPrintCutDiagonalCorner(
            painter,
            i,
            previous_location,
            current_location,
            next_location,
            length,
            zoom
        );
    }
    else if(corner_type === BUMPOUT){
        corner_data = drawPrintCutBumpoutCorner(
            painter,
            i,
            previous_location,
            current_location,
            next_location,
            length,
            depth,
            zoom
        );
    }
    else if(corner_type === RECESSED_DIAGONAL){
        corner_data = drawPrintCutRecessedDiagonalCorner(
            painter,
            i,
            previous_location,
            current_location,
            next_location,
            length,
            depth,
            zoom
        );
    }
    else{
        corner_data = drawPrintCutStandardCorner(
            painter,
            i,
            current_location
        )
    }
    return corner_data;
}


